<template>
  <div class="checkbox-field">
    <div class="flex justify-content-between align-items-center" :class="{ 'hidden': !displayProperties }">
      <label
        class="block"
        data-test-id="checkbox-label"
      >
        {{ t(configs.label, null) }}
      </label>
      <InputSwitch
        v-model="isChecked"
        @update:model-value="handleChange"
      />
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent, PropType, Ref, ref,
} from 'vue';
import { useI18n } from 'vue-i18n';
import InputSwitch from 'primevue/inputswitch';
import { FieldConfig, ParserFieldObject, Property } from '@/types';

export default defineComponent({
  name: 'Checkbox',

  components: {
    InputSwitch,
  },

  props: {
    configs: {
      type: Object as PropType<FieldConfig>,
      required: true,
    },

    parserValues: {
      type: Object as PropType<ParserFieldObject>,
      required: true,
    },

    elementPartType: {
      type: String,
      required: false,
      default: '',
    },
  },

  emits: ['on-change-properties'],

  setup(props, context) {
    const { t } = useI18n();
    const configs = ref(props.configs);
    const displayProperties = ref(!(!Object.prototype.hasOwnProperty.call(configs.value, 'displayToggle') || configs.value.displayToggle === true));
    const property: Ref<Property> = ref(props.parserValues.properties && props.parserValues.properties[0]);

    // Parse boolean from string or boolean
    const parseBoolean = (value: any): boolean => {
      if (typeof value === 'boolean') return value;
      if (typeof value === 'string') return value === 'true';
      return props.configs.options?.defaultValue ?? true;
    };

    const isChecked: Ref<boolean> = ref(parseBoolean(property.value?.value));

    const handleChange = (value: boolean) => {
      isChecked.value = value;

      if (property.value) {
        property.value.value = String(value);
        context.emit('on-change-properties', {
          selector: props.parserValues.selector,
          properties: [property.value],
        });
      }
    };

    return {
      t,
      configs,
      displayProperties,
      isChecked,
      handleChange,
    };
  },
});
</script>

<style scoped lang="scss">
.checkbox-field {
  padding: 0.5rem 0;
}
</style>
